<template>
	<div class="tbl-scroll">
		<table class="tbl" :class="{ nochk: !selectable }">
			<thead>
				<tr>
					<th v-if="selectable" class="chk sticky-l"><input type="checkbox" :checked="allSelected" @change="$emit('selectAll')" /></th>
					<th v-for="col in columns" :key="col.key" :class="[col.sticky ? 'sticky-l2' : '', col.align === 'r' ? 'r' : '', col.sortable ? 'sortable' : '']" @click="col.sortable && $emit('sort', col.sortKey || col.key)">{{ col.label }}<i v-if="col.sortable" class="fa-solid" :class="sortIcon(col.sortKey || col.key)"></i></th>
					<th class="end"></th>
				</tr>
			</thead>
			<tbody v-if="loading"><tr v-for="n in 10" :key="'sk' + n" class="skeleton"><td :colspan="span"><span class="sk"></span></td></tr></tbody>
			<tbody v-else>
				<template v-for="(g, gi) in groupList">
					<tr v-if="g.group" :key="'g:' + (g.group.key || gi)" class="grp"><td v-if="selectable" class="chk sticky-l"></td><td :class="{ 'sticky-l2': stickyFirst }"><slot name="group" :group="g.group"><span v-if="brandClass(g.group.brand)" class="bdot" :class="brandClass(g.group.brand)"></span>{{ g.group.label }}</slot></td><td :colspan="columns.length"></td></tr>
					<template v-for="row in g.rows">
						<tr :key="rid(row)" class="rowable" :class="{ sel: !!selected[rid(row)], open: openId != null && String(openId) === String(rid(row)), inc: !!row.included }" @click="$emit('open', row)">
							<td v-if="selectable" class="chk sticky-l" @click.stop><input v-if="!row.included" type="checkbox" :checked="!!selected[rid(row)]" @change="$emit('select', row)" /></td>
							<td v-for="col in columns" :key="col.key" :class="[col.sticky ? 'sticky-l2' : '', col.align === 'r' ? 'r num' : '']"><slot name="cell" :row="row" :col="col">{{ row[col.key] }}</slot></td>
							<td class="end"></td>
						</tr>
						<slot name="after-row" :row="row"></slot>
					</template>
				</template>
				<tr v-if="!rowCount" class="empty"><td :colspan="span"><i class="fa-regular fa-folder-open"></i><div>{{ emptyText }}</div></td></tr>
			</tbody>
			<tfoot v-if="$scopedSlots.footer"><slot name="footer"></slot></tfoot>
		</table>
	</div>
</template>

<script>
import { brandKey } from './PeBrandChip.vue'

export default {
	name: 'PeTable',
	props: {
		columns: { type: Array, default: () => [] }, // [{ key, label, kind, sortable, sortKey, align ('r'), sticky }]
		rows: { type: Array, default: () => [] },
		rowKey: { type: String, default: 'id' },
		groups: { type: Array, default: null }, // [{ key, label, brand, rows }] renders a tr.grp before each group's rows
		selected: { type: Object, default: () => ({}) }, // { [id]: true }
		selectable: { type: Boolean, default: false },
		openId: { type: [String, Number], default: null },
		loading: { type: Boolean, default: false },
		orderBy: { type: String, default: '' },
		direction: { type: String, default: 'asc' },
		emptyText: { type: String, default: 'No rows match this view.' },
	},
	computed: {
		groupList() { return this.groups ? this.groups.map(g => ({ group: g, rows: g.rows || [] })) : [{ group: null, rows: this.rows || [] }] },
		allRows() { return this.groupList.reduce((a, g) => a.concat(g.rows), []) },
		rowCount() { return this.allRows.length },
		allSelected() { return this.rowCount > 0 && this.allRows.every(r => this.selected[this.rid(r)]) },
		span() { return this.columns.length + (this.selectable ? 1 : 0) + 1 },
		stickyFirst() { return !!(this.columns[0] && this.columns[0].sticky) },
	},
	methods: {
		rid(row) { return row[this.rowKey] },
		sortIcon(key) { if (this.orderBy !== key) return 'fa-sort faint'; return this.direction === 'asc' ? 'fa-sort-up' : 'fa-sort-down' },
		brandClass(brand) { return brandKey(brand).toLowerCase() },
	},
}
</script>
